module.exports = __webpack_public_path__ + "static/img/img_download_valid.5e7d746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_download_valid.png
// module id = d/iE
// module chunks = 1